import { FormattedMessage } from 'react-intl';

import { errorTranslations, warningTranslations } from './messages';

/**
 * @param {import("../../../data/types/types").TranslateImportSummaryErrorType} error
 * @returns {string | JSX.Element}
 */
export const useTranslateImportSummaryError = (error) => {
  if (error.errorCode && error.errorCode !== 'default') {
    if (error.severity === 'warning') {
      if (warningTranslations[error.errorCode]) {
        if (error.constraint) {
          return <FormattedMessage values={{ constraintValue: error.constraint }} {...warningTranslations[error.errorCode]} />;
        }
        return <FormattedMessage {...warningTranslations[error.errorCode]} />;
      }
    }
    if (errorTranslations[error.errorCode]) {
      if (error.constraint) {
        return <FormattedMessage values={{ constraintValue: error.constraint }} {...errorTranslations[error.errorCode]} />;
      }
      return <FormattedMessage {...errorTranslations[error.errorCode]} />;
    }
  }
  return '';
};
